<div class="nim__content-area">
  This device is not registered
</div>

<div class="nim__sidebar">
  <div class="nim__sidebar__top"></div>
  <div class="nim__sidebar__bottom">
  </div>
  <div class="nim__sidebar__global">
    <div nc-global-navigation [isBackEnabled]="false" [isHomeEnabled]="false"></div>
  </div>
</div>
